export const isProdCVSite = window.location.hostname === 'cv.giandigia.dev'
